import React, { Component } from "react";
import { connect } from "react-redux";
import LayoutOperation from "../../components/layout_operation";
import { notification } from "antd";
import { DatePicker,  ConfigProvider } from "antd";
// import { Ui } from "../../services";
import Cookies from "js-cookie";
import ServiceApi from "../../services/ServiceApi";
import { changeLang } from "../../actions/langAction";
import { setDynamic } from "../../actions/dynamicAction";
//import "./report-style.css";//คอมเม้นไว้ก่อนครับเนื่องจาก Layout หน้าอื่นพังไปด้วยครับ Tirapong 7/1/2564
// import { ConsoleSqlOutlined } from "@ant-design/icons";
import moment from 'moment';
import 'moment/locale/th';
// import locale from 'antd/lib/locale/th_TH';
// const { Option } = Select;
// const { RangePicker } = DatePicker;

class ReportList extends Component {
  constructor(props) {
    super(props);

    var endDate = new Date().toISOString().slice(0, 10);
    //var currentTime = moment();
    //var timeReport = moment(currentTime).format("YYYY-MM-DD_HHmmss");
    
    var d = new Date();
    d.setMonth(-1);
    var todayDate = d.toISOString().slice(0, 10);

    this.state = {
      areacode: [],
      vendors: [],
      payType: [
        { payId: "01", payName: "จ้างรายครั้ง" },
        { payId: "02", payName: "จ้างเหมา" },
      ],
      workType: [],
      startdate: todayDate,
      enddate: endDate,
      factUpdate: false,
      LangTranslate: [[]],
      mapStateToProps: [[]],
      mapDispacthToProps: [[]],

      reportSelection: "Form_For_MA_Fiber_Subcontractor",
      jobtypeSelection: "TRS", // ประเภทงาน
      areaSelection: "", // พื้นที่
      areaText: "",
      vendorSelection: "", // ผู้รับเหมา
      vendorText: "", // ชื่อผู้รับเหมา
      payTypeSelection: "", // ประเภทการจ่าย
      workTypeSelection: "", // ประเภทงาน
      downloadReportMessage: ""
    };
  }

  componentDidMount() {
    ServiceApi.post("master_language_detail_get", {
      company_id: Cookies.get("companyid"),
      page_id: 1,
    })
      .then((response) => {
        this.setState({
          LangTranslate: JSON.parse(
            response.data.data["masteR_LANGUAGE_DETAIL"][0].file_json
          ),
          factUpdate: true,
        });
      })
      .catch((e) => {
        console.log(e);
      });

    ServiceApi.post("master_data/work_area_center", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      is_activ: 1,
      where: "",
    }).then((res) => {
        console.log(res.data.data.result);
        this.setState({ areacode: res.data.data.result });
      })
      .catch((e) => {
        console.log(e);
      });

    ServiceApi.post("master_data/GetTeamGroup", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      team_group_duty_code: "O",
    })
      .then((res) => {
        console.log("vendors=" + res.data.list);
        this.setState({ vendors: res.data.list });
      })
      .catch((e) => {
        console.log(e);
      });

    ServiceApi.post("V4/get_job_type", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      pk_id: null,
      fk_id: null,
      is_active: 1,
      effective: 1,
      sql_where: null,
      UserName: Cookies.get("username"),
    })
      .then((res) => {
        console.log(res.data.data);
        this.setState({ workType: res.data.data });
      })
      .catch((e) => {
        console.log(e);
      });

  }

  setArea(value) {
    this.setState({ areaSelection: value });
  }

  setReport(value){
    this.setState({ reportSelection: value });
  }

  setVendor(value) {
    this.setState({ vendorSelection: value });
  }

  setPayType(value) {
    this.setState({ payTypeSelection: value });
  }

  setWorkType(value) {
    this.setState({ workTypeSelection: value });
  }

  setStartDateOnchange(dateString) {
    this.setState({ startdate: dateString });
  }

  setEndDateOnchange(dateString) {
    this.setState({ enddate: dateString });
  }
  notify(type, title, msg) {
    // notification fucntion เรียกใช้โดยการส่ง type (ประเภทการแจ้งเตือน มี error, info, success) , title (ข้อความส่วนหัว), msg รายละเอียดข้อความ
    const args = {
      message: title,
      description: msg,
      duration: 5,
      className: "font-thai-b",
    };
    notification[type](args);
  }

  genExcel() {
    var validate = 0;
    if (this.state.areaSelection == '') {
      validate = 1;
      //type (ประเภทการแจ้งเตือน มี error, info, success) , title (ข้อความส่วนหัว), msg รายละเอียดข้อความ
      this.notify("info", "Informaton", "Please select area choice before.");
    }
    if (this.state.vendorSelection == '') {
      validate = 1;
      this.notify("info", "Informaton", "Please select vendor choice before.");
    }
    if (this.state.payTypeSelection == '') {
      validate = 1;
      this.notify("info", "Informaton", "Please select pay type choice before.");
    }
    if (validate == 0) {

      if(this.state.reportSelection == "Form_For_MA_Fiber_Subcontractor"){
        var api = "get_job_summary_report";
      }else{
        var api = "get_job_summary_report_bts";
      }
      ServiceApi.post(api, {
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        //job_type_id: "TRS",
        area_id: this.state.areaSelection,
        team_group_id: this.state.vendorSelection,
        //pay_type_id: this.state.payTypeSelection,
        //team_group_id: 17,
        start_date: this.state.startdate+ ' 00:00:00',
        end_date: this.state.enddate+ ' 00:00:00',
        //start_date: "2020-12-01 00:00:00",
        //end_date: "2020-12-31 00:00:00",
        vendor_name: this.state.vendorText,
        //work_type_id: this.state.workTypeSelection
      })
        .then((res) => {
          console.log(res.data.result.value);          
          //Form_For_MA_Fiber_Subcontractor_Template_JobSummary.xls
          if(res.data.result.code == "P"){
            this.setState({ downloadReport: res.data.result.value,
              downloadReportMessage: "Please click here to download file."});
          }else{
              this.notify("info", "Informaton", "Is Empty.");
              this.setState({ downloadReportMessage: res.data.result.value});
          }

        })
        .catch((e) => {
          console.log(e);
        });

    }

  }

  setVendorText(e) {
    const splitValue = e.target.value.split("_");
    const vendor_id = splitValue[0];
    const vendor_text = splitValue[1];
    console.log("set vendor_id =" + vendor_id);
    console.log("set vendor_text =" + vendor_text);
    this.setState({
      vendorSelection: vendor_id,
      vendorText: vendor_text,
    });
    // this.state.vendorSelection = vendor_id;
    // this.state.vendorText = vendor_text;
  }

  render() {
    console.log(this.state.LangTranslate);
    const title = "Report Management";
    const locale = Cookies.get("locale");
    return (
      <LayoutOperation active={0}>
        <div className="wrapper-header">
          <div className="container-fluid">
            <div className="d-flex job-header">
              <div className="d-flex align-content-center flex-wrap mr-auto">
                <img
                  src={ServiceApi.absoluteUrl("/icon/bbtec/header/Report.svg")}
                  alt={title}
                  title={title}
                />
                <h2>{title}</h2>
              </div>
            </div>
          </div>
        </div>
        <div className="wrapper-body">
          <div className="row">
            <div className="d-flex align-content-md-start flex-wrap w-100">
              {/* <div id="container-left" className="col col-12 col-md-1"></div> */}
              <div id="container-right" className="col col-12 col-md-12">
                <div className="d-flex justify-content-start align-items-center">
                  <div className="container">
                    <div className="col col-12">
                      <h3>Fault Monthly Report</h3>
                    </div>
                    <div><a href={this.state.downloadReport} target="_blank"><span className="text-danger">{this.state.downloadReportMessage}</span></a></div>
                    <div className="col col-12">
                      <div className="card">
                        <div className="card-body">
                        <div className="form-group row">
                            <label className="col-12 col-sm-3 col-md-2 col-form-label">
                              {this.state.factUpdate
                                ? this.state.LangTranslate[Cookies.get("locale")][
                                "reportName"
                                ]
                                : `Report name`}
                            </label>
                            <div className="col-12 col-sm-9 col-md-8 col-form-input">
                              <select
                                placeholder="Select report"
                                className="w-100"
                                id="reportSelection"
                                onChange={(e) => this.setReport(e.target.value)}
                              >
                                <option value="">เลือกข้อมูล</option>                                
                                <option value="Form_For_MA_Fiber_Subcontractor">Form For MA Fiber Subcontractor</option>
                                <option value="Fault_Monthly_Report">Fault Monthly Report</option>
                              </select>
                            </div>
                          </div>

                          <div className="form-group row">
                            <label className="col-12 col-sm-3 col-md-2 col-form-label">
                              {this.state.factUpdate
                                ? this.state.LangTranslate[Cookies.get("locale")][
                                "areaName"
                                ]
                                : `Area name`}
                            </label>
                            <div className="col-12 col-sm-9 col-md-8 col-form-input">
                              <select
                                placeholder="Select area"
                                className="w-100"
                                id="areaSelection"
                                onChange={(e) => this.setArea(e.target.value)}
                              >
                                <option value="">เลือกข้อมูล</option>
                                {this.state.areacode.map((area_list, index) => (
                                  <option value={area_list.area_code} key={index}>
                                    {area_list.area_code}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="form-group row">
                            <label className="col-12 col-sm-3 col-md-2 col-form-label">
                              {this.state.factUpdate
                                ? this.state.LangTranslate[Cookies.get("locale")][
                                "vendor"
                                ]
                                : `Vendor`}
                            </label>
                            <div className="col-12 col-sm-9 col-md-8 col-form-input">
                              <select
                                placeholder="Select vendor"
                                className="w-100"
                                id="vendorSelection"
                                onChange={(e) => this.setVendorText(e)}
                              >
                                <option value="">เลือกข้อมูล</option>
                                {this.state.vendors.map((vendor_list, index) => (
                                  <option
                                    value={`${vendor_list.team_group_id}_${vendor_list.team_group_name}`}
                                    key={index}
                                  >
                                    {vendor_list.team_group_name}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="form-group row">
                            <label className="col-12 col-sm-3 col-md-2 col-form-label">
                              {this.state.factUpdate
                                ? this.state.LangTranslate[Cookies.get("locale")][
                                "payType"
                                ]
                                : `Pay Type`}
                            </label>
                            <div className="col-12 col-sm-9 col-md-8 col-form-input">
                              <select
                                id="payType"
                                placeholder="Select pay type"
                                className="w-100"
                                onChange={(e) => this.setPayType(e.target.value)}
                              >
                                <option value="">เลือกข้อมูล</option>
                                {this.state.payType.map((payType_list, index) => (
                                  <option value={payType_list.payId} key={index}>
                                    {payType_list.payName}
                                  </option>
                                ))}
                              </select>
                            </div>
                          </div>
                          <div className="form-group row">
                            <label className="col-12 col-sm-3 col-md-2 col-form-label">
                              {this.state.factUpdate
                                ? this.state.LangTranslate[Cookies.get("locale")][
                                "jobType"
                                ]
                                : `Job Type`}
                            </label>
                            <div className="col-12 col-sm-9 col-md-8 col-form-input">
                              <select
                                placeholder="Select job type"
                                className="w-100"
                                id="workType"
                                onChange={(e) => this.setWorkType(e.target.value)}
                              >
                                <option value="All">All</option>
                                {this.state.workType.map(
                                  (workType_list, index) => (
                                    <option
                                      value={workType_list.job_type_id}
                                      key={index}
                                    >
                                      {workType_list.job_type_name}
                                    </option>
                                  )
                                )}
                              </select>
                            </div>
                          </div>
                          <div className="form-group row">
                            <label className="col-12 col-sm-3 col-md-2 col-form-label">
                              {this.state.factUpdate
                                ? this.state.LangTranslate[Cookies.get("locale")][
                                "startDate"
                                ]
                                : `-`}
                            </label>
                            <div className="col-12 col-sm-9 col-md-8 col-form-input">
                              <ConfigProvider locale={locale}>
                                <DatePicker
                                  id="startdate"
                                  format={"YYYY-MM-DD"}
                                  style={{ width: "120px" }}
                                  placeholder={this.state.startdate}
                                  onChange={(date, dateString) =>
                                    this.setStartDateOnchange(dateString)
                                  }
                                  defaultValue={moment(this.state.startdate, 'YYYY-MM-DD')}
                                />
                              </ConfigProvider>
                            </div>
                          </div>
                          <div className="form-group row">
                            <label className="col-12 col-sm-3 col-md-2 col-form-label">
                              {this.state.factUpdate
                                ? this.state.LangTranslate[Cookies.get("locale")][
                                "enddate"
                                ]
                                : `-`}
                            </label>
                            <div className="col-12 col-sm-9 col-md-8 col-form-input">
                              <ConfigProvider locale={locale}>
                                <DatePicker
                                  id="enddate"
                                  style={{ width: "120px" }}
                                  placeholder={this.state.enddate}
                                  onChange={(date, dateString) =>
                                    this.setEndDateOnchange(dateString)
                                  }
                                  defaultValue={moment(this.state.enddate, 'YYYY-MM-DD')}
                                />
                              </ConfigProvider>
                            </div>
                          </div>
                          <div className="form-group row">
                            <label className="col-12 col-sm-3 col-md-2 col-form-label">
                            </label>
                            <div className="col-12 col-sm-9 col-md-8 col-form-input">
                            <button
                              className="btn btn-xs btn-primary"
                              onClick={() => this.genExcel()}><span>OK</span></button>
                              
                              
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div
          className="wrapper-header pr-0 pl-0"
          style={{ height: "284px", marginTop: "-1px" }}
        >
          <div className="row align-items-center mt-3 pl-3">
            <div className="col-12">
              <img
                src={ServiceApi.absoluteUrl("/icon/photo_report_white.svg")}
                className="mr-3"
                alt=""
              />
              <h2 className="c-white text-uppercase m-0 d-inline-block font-mont-b fs-20">
                ReportManagement
              </h2>
            </div>
          </div>
          <div
            className="row align-items-center m-0 mt-3 p-0"
            style={{ backgroundColor: "#FFF", width: "100%" }}
          >
            <div className="col-12 p-0">
              <div className="wrapper-body">
                <div className="row">
                  <div
                    style={{
                      width: "100% !important",
                      display: "block",
                      marginLeft: "80px",
                      width: "80%"
                    }}
                  >
                    <div className="mr-2">
                      <h3>Fault Monthly Report</h3>
                    </div>
                    <div className="card box-content col-12">
                      <div className="card-body">
                        <div className="row col-12">
                          <div className="col-2 w-col-title">
                            {this.state.factUpdate
                              ? this.state.LangTranslate[Cookies.get("locale")][
                              "areaName"
                              ]
                              : `Area name`}
                          </div>
                          <div className="col-10">
                            <select
                              placeholder="Select area"
                              className="inputfile w-col-80"
                              id="areaSelection"
                              onChange={(e) => this.setArea(e.target.value)}
                            >
                              <option value="">เลือกข้อมูล</option>
                              {this.state.areacode.map((area_list, index) => (
                                <option value={area_list.area_code} key={index}>
                                  {area_list.area_code}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="row col-12">
                          <div className="col-2 w-col-title">
                            {this.state.factUpdate
                              ? this.state.LangTranslate[Cookies.get("locale")][
                              "vendor"
                              ]
                              : `Vendor`}
                          </div>
                          <div className="col-10">
                            <select
                              placeholder="Select vendor"
                              className="inputfile w-col-80"
                              id="vendorSelection"
                              onChange={(e) => this.setVendorText(e)}
                            >
                              <option value="">เลือกข้อมูล</option>
                              {this.state.vendors.map((vendor_list, index) => (
                                <option
                                  value={`${vendor_list.team_group_id}_${vendor_list.team_group_name}`}
                                  key={index}
                                >
                                  {vendor_list.team_group_name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="row col-12">
                          <div className="col-2 w-col-title">
                            {this.state.factUpdate
                              ? this.state.LangTranslate[Cookies.get("locale")][
                              "payType"
                              ]
                              : `Pay Type`}
                          </div>
                          <div className="col-10">
                            <select
                              id="payType"
                              placeholder="Select pay type"
                              className="inputfile w-col-80"
                              onChange={(e) => this.setPayType(e.target.value)}
                            >
                              <option value="">เลือกข้อมูล</option>
                              {this.state.payType.map((payType_list, index) => (
                                <option value={payType_list.payId} key={index}>
                                  {payType_list.payName}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="row col-12">
                          <div className="col-2 w-col-title">
                            {this.state.factUpdate
                              ? this.state.LangTranslate[Cookies.get("locale")][
                              "jobType"
                              ]
                              : `Job Type`}
                          </div>
                          <div className="col-10">
                            <select
                              placeholder="Select job type"
                              className="inputfile w-col-80"
                              id="workType"
                              onChange={(e) => this.setWorkType(e.target.value)}
                            >
                              <option value="All">All</option>
                              {this.state.workType.map(
                                (workType_list, index) => (
                                  <option
                                    value={workType_list.job_type_id}
                                    key={index}
                                  >
                                    {workType_list.job_type_name}
                                  </option>
                                )
                              )}
                            </select>
                          </div>
                        </div>

                        <div className="row col-12">
                          <div className="col-2 w-col-title date-title">
                            {this.state.factUpdate
                              ? this.state.LangTranslate[Cookies.get("locale")][
                              "startDate"
                              ]
                              : `-`}
                          </div>
                          <div className="col calendar-during">
                            <ConfigProvider locale={locale}>
                              <DatePicker
                                id="startdate"
                                format={"YYYY-MM-DD"}
                                style={{ width: "120px" }}
                                placeholder={this.state.startdate}
                                onChange={(date, dateString) =>
                                  this.setStartDateOnchange(dateString)
                                }
                                defaultValue={moment(this.state.startdate, 'YYYY-MM-DD')}
                              />
                            </ConfigProvider>
                          </div>
                        </div>

                        <div className="row col-12">
                          <div className="col-2 w-col-title date-title">
                            {this.state.factUpdate
                              ? this.state.LangTranslate[Cookies.get("locale")][
                              "enddate"
                              ]
                              : `-`}
                          </div>
                          <div className="col-10 calendar-during">
                            <ConfigProvider locale={locale}>
                              <DatePicker
                                id="enddate"
                                style={{ width: "120px" }}
                                placeholder={this.state.enddate}
                                onChange={(date, dateString) =>
                                  this.setEndDateOnchange(dateString)
                                }
                                defaultValue={moment(this.state.enddate, 'YYYY-MM-DD')}
                              />
                            </ConfigProvider>
                          </div>
                        </div>

                        <div className="row col-12 pt-2">
                          <Button
                            className="btn btn-warning ml-3 w-60 mb-3"
                            onClick={() => this.genExcel()}
                          >
                            OK
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}

      </LayoutOperation>
    );
  }
}

const mapStateToProps = (state) => ({
  lang: state.lang,
  dynamicReducer: state.dynamicReducer,
});
const mapDispacthToProps = (dispatch) => {
  return {
    changeLang: (data) => dispatch(changeLang(data)),
    setDynamic: (data, visible) => dispatch(setDynamic(data, visible)),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(ReportList);
